import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { v4 as uuid } from 'uuid';
import { environment } from 'src/environments/environment';

@Directive()
export abstract class BaseComponent implements OnDestroy {
    protected readonly destroy$ = new Subject<void>();
    public readonly componentId = uuid();
    public readonly assetsBasePath = `${environment.appBaseUrl}assets/`;

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
